// Per-page FAQ generators for rich-snippet eligibility (schema.org FAQPage).
// Dependency-free (no imports) so the prerender script can load it too.
// Each function returns an array of { q, a } with content interpolated from
// the page's data, so every page gets unique, relevant questions.

function cap(s) {
  return s ? s.charAt(0).toUpperCase() + s.slice(1) : s;
}

export function cityFaq(city) {
  return [
    {
      q: `La voiture sans permis est-elle autorisée ${city.prep} ?`,
      a: `Oui. Une voiture sans permis (quadricycle léger, bridée à 45 km/h) peut circuler ${city.prep} sur le réseau ordinaire, mais pas sur les autoroutes ni les voies rapides comme ${city.road}. vspo trace automatiquement un itinéraire adapté.`,
    },
    {
      q: `Quelles routes faut-il éviter en VSP ${city.prep} ?`,
      a: `${cap(city.prep)}, évitez ${city.road} ainsi que toutes les voies pour automobiles et voies express interdites aux voiturettes. vspo exclut ces axes et reste sur le réseau secondaire autorisé.`,
    },
    {
      q: `vspo est-il gratuit pour rouler ${city.prep} ?`,
      a: `Oui, vspo est 100 % gratuit et sans inscription. Entrez simplement votre point de départ et votre arrivée ${city.prep} pour obtenir un itinéraire adapté à votre voiture sans permis.`,
    },
    {
      q: `Puis-je recharger ma voiture sans permis électrique ${city.prep} ?`,
      a: `Oui. La plupart des voiturettes se rechargent sur une prise domestique 220 V, et certaines bornes publiques ${city.prep} proposent une prise E/F ou Type 2 compatible. vspo aide à les localiser.`,
    },
  ];
}

export function departmentFaq(dept) {
  return [
    {
      q: `Peut-on conduire une voiture sans permis ${dept.prep} (${dept.code}) ?`,
      a: `Oui, dès 14 ans avec le permis AM (ex-BSR). ${cap(dept.prep)}, la VSP circule sur le réseau ordinaire, hors autoroutes et voies rapides. vspo calcule des itinéraires conformes.`,
    },
    {
      q: `vspo couvre-t-il tout le département ${dept.code} ?`,
      a: `Oui. vspo calcule des itinéraires pour voiture sans permis partout ${dept.prep}, en évitant automatiquement les voies interdites aux voiturettes limitées à 45 km/h.`,
    },
    {
      q: `À quel âge peut-on conduire une VSP ${dept.prep} ?`,
      a: `Dès 14 ans avec le permis AM. Les personnes nées avant 1988 peuvent généralement conduire une voiture sans permis sans formalité particulière.`,
    },
  ];
}

export function chargingFaq(city) {
  return [
    {
      q: `Où recharger une voiture sans permis électrique ${city.prep} ?`,
      a: `Sur une prise domestique 220 V à domicile, ou sur certaines bornes publiques ${city.prep} proposant une prise E/F ou Type 2. vspo liste les bornes compatibles les plus proches du centre-ville.`,
    },
    {
      q: `Combien de temps pour recharger une VSP ${city.prep} ?`,
      a: `Comptez généralement 3 à 4 heures sur une prise domestique pour une charge complète, souvent réalisée la nuit. Sur borne rapide compatible, le temps peut être réduit.`,
    },
    {
      q: `Quelle prise pour recharger une Citroën Ami ${city.prep} ?`,
      a: `La Citroën Ami se recharge sur une simple prise domestique 220 V (E/F) grâce à son câble intégré. Dans vspo, filtrez les bornes par type de prise pour trouver celles qui conviennent.`,
    },
  ];
}

export function regionFaq(region) {
  return [
    {
      q: `Peut-on conduire une voiture sans permis ${region.prep} ?`,
      a: `Oui, dès 14 ans avec le permis AM (ex-BSR). ${cap(region.prep)}, la voiture sans permis circule sur le réseau ordinaire, hors autoroutes et voies rapides. vspo calcule des itinéraires conformes dans tous les départements de la région.`,
    },
    {
      q: `vspo couvre-t-il toute la région ${region.name} ?`,
      a: `Oui. vspo calcule des itinéraires pour voiture sans permis dans chaque département de ${region.name}, en évitant automatiquement les voies interdites aux voiturettes limitées à 45 km/h.`,
    },
    {
      q: `Quelles routes éviter en VSP ${region.prep} ?`,
      a: `Autoroutes, voies express, rocades et périphériques sont interdits aux voitures sans permis. vspo les exclut et vous maintient sur le réseau secondaire autorisé, avec navigation vocale et trafic en temps réel.`,
    },
  ];
}

export function tripFaq(from, to) {
  return [
    {
      q: `Peut-on aller de ${from.name} à ${to.name} en voiture sans permis ?`,
      a: `Oui, à condition d'éviter les autoroutes et les voies rapides. vspo calcule une liaison ${from.name} → ${to.name} adaptée aux voiturettes limitées à 45 km/h, sur le réseau ordinaire.`,
    },
    {
      q: `Combien de temps pour relier ${from.name} et ${to.name} en VSP ?`,
      a: `À 45 km/h, la durée dépend de la distance réelle par le réseau autorisé. vspo affiche le temps estimé en évitant les voies interdites aux voitures sans permis.`,
    },
    {
      q: `vspo évite-t-il les voies rapides entre ${from.name} et ${to.name} ?`,
      a: `Oui. vspo exclut automatiquement autoroutes, rocades et voies express des deux secteurs (${from.road} ou ${to.road}, par exemple) et reste sur le réseau autorisé aux VSP.`,
    },
  ];
}
